import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/lib/useLenis";
import { LangProvider } from "@/lib/i18n";

export const Layout = ({ lang }) => {
  const lenis = useLenis();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === "/" && !sessionStorage.getItem("lang-applied")) {
      sessionStorage.setItem("lang-applied", "1");
      if (localStorage.getItem("lang") === "en") navigate("/en", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    if (lenis.current) lenis.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);

  return (
    <LangProvider lang={lang}>
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </LangProvider>
  );
};
